import { render, staticRenderFns } from "./SpaceSettingsCreateBtn.vue?vue&type=template&id=6cb65a73&scoped=true&"
import script from "./SpaceSettingsCreateBtn.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsCreateBtn.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSettingsCreateBtn.vue?vue&type=style&index=0&id=6cb65a73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb65a73",
  null
  
)

export default component.exports